import { createSlice } from "@reduxjs/toolkit";

export const dashboardLogin = createSlice({
  name: "dashboard-login",
  initialState: {
    value: {
      connected: false,
      tokenLogin: null,
    },
  },
  reducers: {

    //TODO criar metodo set
    getConnected(state, { payload }) {
      state.value.connected = payload;
      window.localStorage.setItem("isConnected", state.value.connected);
    },

    //TODO criar metodo set
    setTokenLogin(state, { payload }) {
      state.value.tokenLogin = payload;
    },
  },
});

export const { getConnected, setTokenLogin } = dashboardLogin.actions;
export default dashboardLogin.reducer;
